import {SecureService} from "@/services/superclasses/secure-service";
import {Duration} from "@/interfaces/duration";

const api = window.contextPath + '/rest/durations';

export class DurationSecureService extends SecureService {

    public loadAll = async (): Promise<Duration[]> => {
        return this.data(await this.get<Duration[]>(api))
    }
}

export const durationSecureService = new DurationSecureService()